const contractAddress = "0xCFefF8E228d138dE7B4061008f0eF8d31FaD527E";
export default contractAddress;